module.exports = __webpack_public_path__ + "media/img/frontend_application/notification/event_planner/event_finished-5cf274f3795b7fae51cdae8b5280184a.png";